import React, { useState } from "react";
import { Button, Input } from "../design-system";

// Login migrado para o Design System (dark mode). Auth real continua via onLogin (App.jsx).
// Sem seletor de tipo (15/07): com 4 papéis o toggle Professor/Administrador
// virou ruído — o papel vem do profile e o HomeRedirect direciona sozinho.
const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) {
      setError("Por favor, preencha todos os campos");
      return;
    }
    setLoading(true);
    try {
      // App.jsx faz o signIn + navega em caso de sucesso.
      const result = await onLogin(email, password);
      if (result && result.success === false) {
        setError(result.error || "Email ou senha incorretos.");
      }
    } catch (err) {
      console.error("Exceção no login:", err?.message);
      setError("Ocorreu um erro inesperado. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--color-black-pure)",
        fontFamily: "var(--font-body)",
        padding: "var(--space-4)",
      }}
    >
      <div
        style={{
          width: 380,
          maxWidth: "92vw",
          background: "var(--surface-dark)",
          border: "1px solid var(--border-on-dark)",
          borderRadius: "var(--radius-xl)",
          padding: "40px 34px",
          boxShadow: "var(--shadow-xl)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "var(--space-6)" }}>
          <div
            style={{
              fontFamily: "var(--font-display)",
              fontWeight: 900,
              fontSize: "2rem",
              color: "var(--color-green)",
              textTransform: "uppercase",
              letterSpacing: "var(--tracking-wide)",
              lineHeight: 1,
            }}
          >
            Iron House
          </div>
          <div
            style={{
              color: "var(--color-green)",
              fontFamily: "var(--font-display)",
              textTransform: "uppercase",
              letterSpacing: "var(--tracking-widest)",
              fontSize: "0.72rem",
              fontWeight: 700,
              marginTop: "var(--space-1)",
            }}
          >
            Health &amp; Performance
          </div>
        </div>

        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
          <Input
            label="E-mail"
            type="email"
            variant="dark"
            value={email}
            onChange={setEmail}
            placeholder="seu@email.com"
            disabled={loading}
            autoComplete="email"
          />
          <Input
            label="Senha"
            type="password"
            variant="dark"
            value={password}
            onChange={setPassword}
            placeholder="••••••••"
            disabled={loading}
            autoComplete="current-password"
          />

          {error && (
            <div style={{ color: "var(--color-error)", fontSize: "13px", fontWeight: 600 }}>{error}</div>
          )}

          <Button type="submit" variant="primary" size="lg" fullWidth disabled={loading}>
            {loading ? "Entrando…" : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
